export const data = {
  labels: [
    'JS',
    'TS',
    'Vue',
    'React',
    'HTML/CSS',
    'Python',
    'Laravel',
    'Tooling',
    'DevOps',
    'Design',
  ],
  datasets: [
    {
      label: '',
      backgroundColor: 'rgba(206, 220, 0, 0.25)',
      borderColor: 'rgba(206, 220, 0, 0.5)',
      pointBackgroundColor: '#cedc00',
      pointBorderColor: '#cedc00',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(179,181,198,1)',
      data: [
        100, // JS
        50, // TS
        100, // Vue
        60, // React
        100, // HTML/CSS
        35, // Python
        45, // Laravel
        90, // Tooling
        85, // DevOps
        65, // Design
      ],
    },
  ],
};

export const options = {
  responsive: false,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    r: {
      beginAtZero: true,
      suggestedMin: 0,
      suggestedMax: 100,
      grid: {
        color: 'rgba(255, 255, 255, 0.25)',
      },
      angleLines: {
        color: 'rgba(255, 255, 255, 0.5)',
      },
      pointLabels: {
        color: '#fff',
      },
      ticks: {
        display: false,
      },
    },
  },
};
